// Bookmark API — authenticated endpoints for listing and toggling bookmarks
import { EventResponse } from '@/types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

// ─── Types ──────────────────────────────────────────────────────────────────

export interface BookmarkItem {
  bookmarkId: number;
  bookmarkedAt: string;
  event: EventResponse | EventResponse[];
}

export interface GetBookmarksParams {
  limit?: number;
  offset?: number;
}

export interface GetBookmarksResponse {
  success: boolean;
  data: BookmarkItem[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export interface ToggleBookmarkResponse {
  success: boolean;
  data?: {
    bookmarked: boolean;
    bookmarkId?: number;
  };
  message?: string;
}

// ─── API ────────────────────────────────────────────────────────────────────

export const bookmarkApi = {
  /**
   * Fetch a paginated list of bookmarks for the authenticated user.
   */
  getBookmarks: async (params: GetBookmarksParams = {}): Promise<GetBookmarksResponse> => {
    const { data } = await axiosClient.get<GetBookmarksResponse>(API_ENDPOINTS.BOOKMARKS.LIST, {
      params,
    });
    return data;
  },

  /**
   * Toggle bookmark status for an event.
   * POST /api/v1/bookmarks/toggle-bookmark with { eventId }
   */
  toggleBookmark: async (eventId: string): Promise<ToggleBookmarkResponse> => {
    const { data } = await axiosClient.post<ToggleBookmarkResponse>(
      API_ENDPOINTS.BOOKMARKS.TOGGLE,
      { eventId }
    );
    return data;
  },
};
